import theme from '@ifca-root/react-component/src/assets/theme'
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog'
import { Footer } from '@ifca-root/react-component/src/components/Footer/Footer'
import DynamicSubHeader from '@ifca-root/react-component/src/components/Header/DynamicSubHeader'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { useExcelUploadVersion2 } from '@ifca-root/react-component/src/utils/hooks/excelUploadVersion2'
import {
  CircularProgress,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
} from '@material-ui/core'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import {
  useCreateAssetRegistrationExcelMutation,
  useGetAssetRegistrationImportCheckingValidationLazyQuery,
  useImportAssetRegistrationExcelMutation,
} from 'generated/graphql'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import { formatDate } from 'helpers/StringNumberFunction/FormatDate'
import { amtNumStr, amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import React, { useContext, useEffect, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useHistory } from 'react-router'
import { useLocation, useParams } from 'react-router-dom'
import { AssetRegistrationTemplateForm } from './AssetRegistrationExcelFn'
import { BatchExcelInput } from './BatchExcelInput'

export const AssetRegistrationImportExcelValidation = (props: any) => {
  let location = useLocation()
  const passedData: any = location?.state
  const fileName = passedData.fileTitle
  let history = useHistory()
  const { CompanyID, BatchID }: any = useParams()

  let user = JSON.parse(localStorage.getItem('loggedInUser'))
  const { setOpenSnackBar, setSnackBarMsg }: any = useContext(
    SnackBarContext as any
  )
  const [validatedData, setValidatedData] = useState<any>({
    ErrorData: [],
    ValidData: [],
  })
  const [openUpload, setOpenUpload] = useState(null)
  const [openDialog, setOpenDialog] = useState(null)
  const [allList, setAllList] = useState([])
  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)

  let validationPath = `/fixed-assets/${CompanyID}/assets-registration/import-asset-registration-validation/${BatchID}`
  let backPath = `/fixed-assets/${CompanyID}/assets-registration`
  let itemLabel = 'Asset Registration'
  let moduleLabel = 'Fixed Assets'

  /* -------------------------------------------- */
  /*                     QUERY                    */
  /* -------------------------------------------- */

  const [
    loadData,
    {
      loading: AssetRegistrationImportCheckingValidationLoading,
      data: { getAssetRegistrationImportCheckingValidation } = {
        getAssetRegistrationImportCheckingValidation: [],
      },
    },
  ] = useGetAssetRegistrationImportCheckingValidationLazyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: ({ getAssetRegistrationImportCheckingValidation }) => {
      if (getAssetRegistrationImportCheckingValidation?.length > 0) {
        let ErrorData: any = []
        let ValidData: any = []

        getAssetRegistrationImportCheckingValidation?.map(x => {
          if (x['err_status'] === true)
            ErrorData.push({
              asset_card_no: x['asset_card_no'],
              registration_date: x['registration_date'],
              start_use_date: x['start_use_date'],
              name: x['name'],
              fa_category_code: x['fa_category_code'],
              fa_source_name: x['fa_source_name'],
              uom_code: x['uom_code'],
              base_original_amount: x['base_original_amount'],
              residual: x['residual'],
              residual_value: x['residual_value'],
              unit_price: x['unit_price'],
              original_net_amount: x['original_net_amount'],
              fa_depreciation_method_name: x['fa_depreciation_method_name'],
              depreciation_start_year: x['depreciation_start_year'],
              depreciation_start_period: x['depreciation_start_period'],
              opening_accumulated_depreciation:
                x['opening_accumulated_depreciation'],
              opening_depreciation_useful_life:
                x['opening_depreciation_useful_life'],
              depreciation_utilized_useful_life:
                x['depreciation_utilized_useful_life'],
              model_no: x['model_no'],
              ref_no: x['ref_no'],
              remark: x['remark'],
              cost_centre_code: x['cost_centre_code'],
              department_quantity: x['department_quantity'],
              department_uom_code: x['department_uom_code'],
              fa_location_name: x['fa_location_name'],
              RowNo: x['RowNo'],
              ErrorList: x['err_remarks'],
            })
          else
            ValidData.push({
              asset_card_no: x['asset_card_no'],
              registration_date: x['registration_date'],
              start_use_date: x['start_use_date'],
              name: x['name'],
              fa_category_code: x['fa_category_code'],
              fa_source_name: x['fa_source_name'],
              uom_code: x['uom_code'],
              base_original_amount: x['base_original_amount'],
              residual: x['residual'],
              residual_value: x['residual_value'],
              unit_price: x['unit_price'],
              original_net_amount: x['original_net_amount'],
              fa_depreciation_method_name: x['fa_depreciation_method_name'],
              depreciation_start_year: x['depreciation_start_year'],
              depreciation_start_period: x['depreciation_start_period'],
              opening_accumulated_depreciation:
                x['opening_accumulated_depreciation'],
              opening_depreciation_useful_life:
                x['opening_depreciation_useful_life'],
              depreciation_utilized_useful_life:
                x['depreciation_utilized_useful_life'],
              model_no: x['model_no'],
              ref_no: x['ref_no'],
              remark: x['remark'],
              cost_centre_code: x['cost_centre_code'],
              department_quantity: x['department_quantity'],
              department_uom_code: x['department_uom_code'],
              fa_location_name: x['fa_location_name'],
              RowNo: x['RowNo'],
              ErrorList: x['err_remarks'],
            })
        })

        setValidatedData({ ErrorData: ErrorData, ValidData: ValidData })
        setAllList([
          ...allList,
          ...[...validatedData.ErrorData, ...validatedData.ValidData],
        ])
      }
    },
  })

  const [
    ImportAssetExcel,
    { loading: ImportAssetRegistrationExcelLoading },
  ] = useImportAssetRegistrationExcelMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
      resetFileUpload()
      setFileTitle('')
      setCurrentData([])
      setOpenUpload(false)
    },
    onCompleted: data => {
      resetFileUpload()
      setFileTitle('')
      setCurrentData([])
      setOpenUpload(false)
      setValidatedData({ ErrorData: [], ValidData: [] })
      loadData({
        variables: {
          BatchID: BatchID ?? passedData?.BatchID,
          take: 30,
          skip: 0,
        },
      })
      history.push({
        pathname: validationPath,
        state: {
          BatchID: BatchID,
          fileTitle: fileTitle,
        },
      })
    },
  })

  const [
    ConfirmUpload,
    { loading: CreateAssetRegistrationExcelLoading },
  ] = useCreateAssetRegistrationExcelMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: data => {
      resetFileUpload()
      setFileTitle('')
      setCurrentData([])
      setOpenUpload(false)
      history.push({
        pathname: backPath,
      })
      setSnackBarMsg(SystemMsgs.createNewRecord)
      setOpenSnackBar(true)
    },
  })

  useEffect(() => {
    loadData({
      variables: {
        BatchID: BatchID ?? passedData?.BatchID,
        take: 30,
        skip: 0,
      },
    })
  }, [])

  /* -------------------------------------------- */
  /*                     VARIABLE                 */
  /* -------------------------------------------- */

  const {
    openFileUpload,
    setOpenFileUpload,
    fileTitle,
    setFileTitle,
    openSnackBar,
    snackBarMessage,
    setSnackBarMessage,
    currentData,
    setCurrentData,
    onDownloadTemplate,
    onSelectFile,
    duplicateItems,
    errorDialog: duplicateErrorDia,
    setErrorDialog,
    resetFileUpload,
  } = useExcelUploadVersion2()

  const isDesktop = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  })

  const onConfirm = () => {
    ConfirmUpload({ variables: { BatchID } })
  }

  /* -------------------------------------------- */
  /*                     IMPORT                   */
  /* -------------------------------------------- */

  const onImport = data => {
    const filteredData = data?.filter(x => {
      return (
        (x?.asset_card_no && x?.asset_card_no !== '') ||
        (x?.name && x?.name !== '') ||
        x?.registration_date
      )
    })

    ImportAssetExcel({
      variables: {
        BatchID: BatchID,
        CompanyID: CompanyID,
        AssetRegistrationImportInput: filteredData?.map((x, index) => {
          return {
            asset_card_no:
              x?.asset_card_no === null ? null : `${x?.asset_card_no}`,
            registration_date:
              x?.registration_date === null
                ? null
                : new Date(x?.registration_date).toISOString(),
            start_use_date:
              x?.start_use_date === null
                ? null
                : new Date(x?.start_use_date).toISOString(),
            name: x?.name === null ? null : `${x?.name}`,
            fa_category_code:
              x?.fa_category_code === null ? null : `${x?.fa_category_code}`,
            fa_source_name:
              x?.fa_source_name === null ? null : `${x?.fa_source_name}`,
            uom_code: x?.uom_code === null ? null : `${x?.uom_code}`,
            base_original_amount:
              x?.base_original_amount === null
                ? null
                : Number(x?.base_original_amount),
            residual: x?.residual === null ? null : Number(x?.residual),
            residual_value:
              x?.residual_value === null ? null : Number(x?.residual_value),
            unit_price: x?.unit_price === null ? null : Number(x?.unit_price),
            fa_depreciation_method_name:
              x?.fa_depreciation_method_name === null
                ? null
                : `${x?.fa_depreciation_method_name}`,
            depreciation_start_year:
              x?.depreciation_start_year === null
                ? null
                : Number(x?.depreciation_start_year),
            depreciation_start_period:
              x?.depreciation_start_period === null
                ? null
                : Number(x?.depreciation_start_period),
            opening_accumulated_depreciation:
              x?.opening_accumulated_depreciation === null
                ? null
                : Number(x?.opening_accumulated_depreciation),
            opening_depreciation_useful_life:
              x?.opening_depreciation_useful_life === null
                ? null
                : Number(x?.opening_depreciation_useful_life),
            depreciation_utilized_useful_life:
              x?.depreciation_utilized_useful_life === null
                ? null
                : Number(x?.depreciation_utilized_useful_life),
            model_no: x?.model_no === null ? null : `${x?.model_no}`,
            ref_no: x?.ref_no === null ? null : `${x?.ref_no}`,
            remark: x?.remark === null ? null : `${x?.remark}`,
            cost_centre_code:
              x?.cost_centre_code === null ? null : `${x?.cost_centre_code}`,
            department_quantity:
              x?.department_quantity === null
                ? null
                : Number(x?.department_quantity),
            fa_location_name:
              x?.fa_location_name === null ? null : `${x?.fa_location_name}`,
            department_uom_code:
              x?.department_uom_code === null
                ? null
                : `${x?.department_uom_code}`,
            RowNo: index + 2,
          }
        }),
      },
    })
  }

  return (
    <>
      {ImportAssetRegistrationExcelLoading && <Loading />}
      {CreateAssetRegistrationExcelLoading && <Loading />}
      {AssetRegistrationImportCheckingValidationLoading && <Loading />}
      <MainHeader
        mainBtn="close"
        onClick={() => history.push(backPath)}
        smTitle={moduleLabel}
        title={user?.accountName}
        routeSegments={[
          { name: 'Main Menu' },
          { name: itemLabel, current: true },
        ]}
      />

      <DynamicSubHeader
        style={{
          marginTop: '-2px',
        }}
        title={`${itemLabel} Excel Upload`}
        rightText={<span className="c-orange">Validation</span>}
      />
      <List className="search-header fixed-search-header with-dynamic">
        <ListItem>
          <ListItemText
            primary={
              <div style={{ width: '100%' }}>
                <div className="xsTitle">{fileName}</div>
              </div>
            }
          />
        </ListItem>
      </List>

      <ContentWrapper
        style={{ marginTop: isDesktop ? '140px' : '75px' }}
        float
        footer
      >
        <InfiniteScroll
          dataLength={allList?.length}
          next={() => {
            loadData({
              variables: {
                BatchID: BatchID ?? passedData?.BatchID,
                skip: allList?.length,
                take: 30,
              },
            })
          }}
          hasMore={true}
          className=""
          style={{ padding: '8px 6px' }}
          loader={
            AssetRegistrationImportCheckingValidationLoading && (
              <div style={{ textAlign: 'center' }}>
                <CircularProgress />
              </div>
            )
          }
          endMessage={
            <p style={{ textAlign: 'center' }}>
              <b>-</b>
            </p>
          }
        >
          {/* Problem List */}
          {validatedData.ErrorData?.length > 0 && (
            <>
              <List style={{ marginBottom: '-13px' }}>
                <ListItem>
                  <ListItemText
                    primary={
                      <>
                        <span
                          className="xsTitle"
                          style={{ marginLeft: '-9px' }}
                        >
                          Problem{' '}
                          {
                            <>
                              (
                              <span className="highlight-text">
                                {validatedData.ErrorData?.length}
                              </span>
                              )
                            </>
                          }
                        </span>
                      </>
                    }
                  />
                </ListItem>
              </List>
              <List className="core-list">
                {validatedData.ErrorData?.map((el, index) => (
                  <ListItem key={index}>
                    <ListItemText
                      primary={
                        <>
                          <div style={{ width: '100%' }}>
                            <div>
                              <span className="xsTitle flex-space">
                                Asset Card No:{' '}
                              </span>
                              <span className="mdDesc flex-space">
                                {el.asset_card_no}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space">
                                Ref No:{' '}
                              </span>
                              <span className="mdDesc flex-space">
                                {el.ref_no}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space">Name: </span>
                              <span className="mdDesc flex-space">
                                {el.name}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space">
                                Registration Date:{' '}
                              </span>
                              <span className="mdDesc flex-space">
                                {formatDate(el.registration_date)}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space">
                                Start Using Date:{' '}
                              </span>
                              <span className="mdDesc flex-space">
                                {formatDate(el.start_use_date)}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space">
                                Category Code:{' '}
                              </span>
                              <span className="mdDesc flex-space">
                                {el.fa_category_code}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space">
                                Source:{' '}
                              </span>
                              <span className="mdDesc flex-space">
                                {el.fa_source_name}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space">
                                Model No:{' '}
                              </span>
                              <span className="mdDesc flex-space">
                                {el.model_no}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space">
                                UOM Code:{' '}
                              </span>
                              <span className="mdDesc flex-space">
                                {el.uom_code}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space">
                                Base Original Amount:{' '}
                              </span>
                              <span className="mdDesc flex-space">
                                {amtStr(el.base_original_amount)}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space">
                                Residual %:{' '}
                              </span>
                              <span className="mdDesc flex-space">
                                {amtStr(el.residual)}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space">
                                Residual Value:{' '}
                              </span>
                              <span className="mdDesc flex-space">
                                {amtStr(el.residual_value)}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space">
                                Net Amount:{' '}
                              </span>
                              <span className="mdDesc flex-space">
                                {amtStr(el.original_net_amount)}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space">
                                Depreciation Method:{' '}
                              </span>
                              <span className="mdDesc flex-space">
                                {el.fa_depreciation_method_name}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space">
                                Start Year:{' '}
                              </span>
                              <span className="mdDesc flex-space">
                                {el.depreciation_start_year}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space">
                                Start Period:{' '}
                              </span>
                              <span className="mdDesc flex-space">
                                {el.depreciation_start_period}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space">
                                Acc. Depreciation:{' '}
                              </span>
                              <span className="mdDesc flex-space">
                                {amtStr(el.opening_accumulated_depreciation)}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space">
                                Useful Life (Period):{' '}
                              </span>
                              <span className="mdDesc flex-space">
                                {el.opening_depreciation_useful_life}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space">
                                Utilized Useful Life (Period):{' '}
                              </span>
                              <span className="mdDesc flex-space">
                                {el.depreciation_utilized_useful_life}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space">
                                Department Code:{' '}
                              </span>
                              <span className="mdDesc flex-space">
                                {el.cost_centre_code}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space">
                                Location Name:{' '}
                              </span>
                              <span className="mdDesc flex-space">
                                {el.fa_location_name}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space">
                                Assigned Quantity:{' '}
                              </span>
                              <span className="mdDesc flex-space">
                                {amtStr(el.department_quantity)}
                              </span>
                            </div>

                            {el.remark && (
                              <div>
                                <span className="xsTitle flex-space">
                                  Remark:{' '}
                                </span>
                                <span className="mdDesc flex-space">
                                  {el.remark}
                                </span>
                              </div>
                            )}
                          </div>
                        </>
                      }
                      secondary={
                        <>
                          <div>
                            <div
                              className="xsTitle text-noflow"
                              style={{ color: 'red' }}
                            >
                              Row No: {el.RowNo}
                            </div>
                            <div
                              className="xsTitle text-noflow"
                              style={{ color: 'red' }}
                            >
                              {el.ErrorList}
                            </div>
                          </div>
                        </>
                      }
                    />
                  </ListItem>
                ))}
              </List>
            </>
          )}

          {/* Validation List */}
          {validatedData.ValidData?.length > 0 && (
            <>
              <List style={{ marginBottom: '-13px' }}>
                <ListItem>
                  <ListItemText
                    primary={
                      <>
                        <span
                          className="xsTitle"
                          style={{ marginLeft: '-9px' }}
                        >
                          Validated{' '}
                          {
                            <>
                              (
                              <span className="highlight-text">
                                {validatedData.ValidData?.length}
                              </span>
                              )
                            </>
                          }
                        </span>
                      </>
                    }
                  />
                </ListItem>
              </List>
              <List className="core-list">
                {validatedData.ValidData?.map((el, index) => (
                  <ListItem key={index}>
                    <ListItemText
                      primary={
                        <>
                          <div style={{ width: '100%' }}>
                            <div>
                              <span className="xsTitle flex-space">
                                Asset Card No:{' '}
                              </span>
                              <span className="mdDesc flex-space">
                                {el.asset_card_no}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space">
                                Ref No:{' '}
                              </span>
                              <span className="mdDesc flex-space">
                                {el.ref_no}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space">Name: </span>
                              <span className="mdDesc flex-space">
                                {el.name}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space">
                                Registration Date:{' '}
                              </span>
                              <span className="mdDesc flex-space">
                                {formatDate(el.registration_date)}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space">
                                Start Using Date:{' '}
                              </span>
                              <span className="mdDesc flex-space">
                                {formatDate(el.start_use_date)}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space">
                                Category Code:{' '}
                              </span>
                              <span className="mdDesc flex-space">
                                {el.fa_category_code}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space">
                                Source:{' '}
                              </span>
                              <span className="mdDesc flex-space">
                                {el.fa_source_name}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space">
                                Model No:{' '}
                              </span>
                              <span className="mdDesc flex-space">
                                {el.model_no}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space">
                                UOM Code:{' '}
                              </span>
                              <span className="mdDesc flex-space">
                                {el.uom_code}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space">
                                Base Original Amount:{' '}
                              </span>
                              <span className="mdDesc flex-space">
                                {amtStr(el.base_original_amount)}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space">
                                Residual %:{' '}
                              </span>
                              <span className="mdDesc flex-space">
                                {amtStr(el.residual)}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space">
                                Residual Value:{' '}
                              </span>
                              <span className="mdDesc flex-space">
                                {amtStr(el.residual_value)}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space">
                                Net Amount:{' '}
                              </span>
                              <span className="mdDesc flex-space">
                                {amtStr(el.original_net_amount)}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space">
                                Depreciation Method:{' '}
                              </span>
                              <span className="mdDesc flex-space">
                                {el.fa_depreciation_method_name}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space">
                                Start Year:{' '}
                              </span>
                              <span className="mdDesc flex-space">
                                {el.depreciation_start_year}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space">
                                Start Period:{' '}
                              </span>
                              <span className="mdDesc flex-space">
                                {el.depreciation_start_period}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space">
                                Acc. Depreciation:{' '}
                              </span>
                              <span className="mdDesc flex-space">
                                {amtStr(el.opening_accumulated_depreciation)}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space">
                                Useful Life (Period):{' '}
                              </span>
                              <span className="mdDesc flex-space">
                                {el.opening_depreciation_useful_life}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space">
                                Utilized Useful Life (Period):{' '}
                              </span>
                              <span className="mdDesc flex-space">
                                {el.depreciation_utilized_useful_life}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space">
                                Department Code:{' '}
                              </span>
                              <span className="mdDesc flex-space">
                                {el.cost_centre_code}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space">
                                Location Name:{' '}
                              </span>
                              <span className="mdDesc flex-space">
                                {el.fa_location_name}
                              </span>
                            </div>

                            <div>
                              <span className="xsTitle flex-space">
                                Assigned Quantity:{' '}
                              </span>
                              <span className="mdDesc flex-space">
                                {amtStr(el.department_quantity)}
                              </span>
                            </div>

                            {el.remark && (
                              <div>
                                <span className="xsTitle flex-space">
                                  Remark:{' '}
                                </span>
                                <span className="mdDesc flex-space">
                                  {el.remark}
                                </span>
                              </div>
                            )}
                          </div>
                        </>
                      }
                    />
                  </ListItem>
                ))}
              </List>
            </>
          )}
        </InfiniteScroll>
      </ContentWrapper>

      <Footer
        options={
          validatedData.ErrorData?.length === 0 &&
          validatedData.ValidData?.length > 0
            ? [
                {
                  onClick: () => {
                    setOpenDialog(true)
                  },
                  name: 'Confirm Upload',
                  color: 'primary',
                },
              ]
            : [
                {
                  name: 'Re-upload',
                  color: 'primary',
                  onClick: () => {
                    setOpenFileUpload(true)
                  },
                },
              ]
        }
      />

      <BatchExcelInput
        showDupErrors={false}
        duplicateItems={duplicateItems}
        errorDia={duplicateErrorDia}
        setErrorDia={setErrorDialog}
        openUpload={openFileUpload}
        setOpenUpload={setOpenFileUpload}
        upload={fileTitle}
        template={currentData}
        setTemplate={setCurrentData}
        setUpload={setFileTitle}
        resetFileUpload={resetFileUpload}
        showFooter={false}
        labelDisplay={'Asset Registration'}
        onUploadTemplate={() => {
          onImport(currentData)
          setOpenFileUpload(false)
          localStorage.removeItem('searchFilter')
        }}
        onSelectFile={(e: any) => {
          onSelectFile({ event: e })
        }}
        onDownloadTemplate={() =>
          onDownloadTemplate({
            name: `Asset Registration Template`,
            workSheetName: `Asset List`,
            headerSetup: AssetRegistrationTemplateForm,
            isHeaderLocked: true,
            defaultHeaderFillStyle: {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'D3D3D3' },
            },
            defaultHeaderBorderStyle: {
              top: { style: 'thin' },
              left: { style: 'thin' },
              bottom: { style: 'thin' },
              right: { style: 'thin' },
            },
            listType: {
              hasCountry: true,
              hasNationality: true,
            },
          })
        }
        snackBarProps={{
          openSnackBar: openSnackBar,
          snackBarMessage: snackBarMessage,
          setOpenSnackBar: setOpenSnackBar,
          onClickButton: () => {
            setOpenSnackBar(false)
          },
        }}
      />

      <CommonDialog
        fullWidth={true}
        open={openDialog}
        onClose={() => {
          setOpenDialog(false)
        }}
        sections={{
          header: {
            dynamic: (
              <div className="">
                <div className="dialog-dynamic-content">
                  <span
                    className="title c-orange flex-space"
                    style={{
                      fontSize: '13px',
                      fontWeight: 'bold',
                    }}
                  >
                    Upload Confirmation
                  </span>
                </div>
              </div>
            ),
          },
          body: () => (
            <div>
              <span>{'Are you sure to upload?'}</span>
            </div>
          ),

          footer: {
            actions: [
              {
                displayText: 'Cancel',
                props: {
                  onClick: () => {
                    setOpenDialog(false)
                  },
                  variant: 'contained',
                  color: 'primary',
                },
              },
              {
                displayText: 'Confirm',
                props: {
                  onClick: () => {
                    onConfirm()
                  },
                  variant: 'contained',
                  color: 'primary',
                },
              },
            ],
          },
        }}
      />
      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />
    </>
  )
}
